import styled from 'styled-components';
import { colors, fontFamilySize, px } from '../../../../contrib/ui';

export const ScorersContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  .game-index {
    padding: 0 ${px(20)};
    ${fontFamilySize('Heavy', 30)};
    color: ${colors.dark};
  }

  .scorer-paper {
    flex-grow: 1;
  }
`;
